import React, { useEffect } from 'react';

import { LogoType, Size } from 'coreOld/enums';
import { useGetLogoPaths } from 'coreOld/hooks';
import { useNotification } from 'coreOld/hooks/useNotification';

import { ModalDialog } from './ModalDialog';
import { ModalHorizontalDialog } from './ModalHorizontalDialog';
import ModalView from './ModalView';

interface IProps {
  title: string;
  subtitle?: string | JSX.Element;
  isOpen?: boolean;
  onClose?: () => void;
  size?: Size;
  height?: number;
  minWidth?: number | string;
  shouldCloseOnOverlayClick?: boolean;
  children?: React.ReactNode | React.ReactNode[];
  hasContent?: boolean;
  horizontal?: boolean;
  parentSelector?: () => HTMLElement;
  flexHeader?: number;
  borderColor?: string;
  backgroundColor?: string;
}

const Modal = ({
  title,
  subtitle,
  isOpen,
  onClose,
  size,
  height,
  minWidth,
  shouldCloseOnOverlayClick = false,
  children,
  hasContent = true,
  horizontal = false,
  parentSelector,
  flexHeader,
  borderColor,
  backgroundColor,
}: IProps) => {
  const { clearNotification } = useNotification();
  const { logoPaths } = useGetLogoPaths();

  useEffect(() => {
    if (isOpen) {
      clearNotification();
    }
  }, [isOpen]);

  const ModalDialogComponenet = horizontal ? ModalHorizontalDialog : ModalDialog;

  return (
    <ModalDialogComponenet
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      height={height}
      minWidth={minWidth}
      parentSelector={parentSelector}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      borderColor={borderColor}
    >
      <ModalView
        title={title}
        subtitle={subtitle}
        logoPath={logoPaths?.[LogoType.SMALL]}
        closeModal={onClose}
        hasContent={hasContent}
        horizontal={horizontal}
        flexHeader={flexHeader}
        height={height}
        backgroundColor={backgroundColor}
      >
        {children}
      </ModalView>
    </ModalDialogComponenet>
  );
};

export default Modal;
